export const PAYMENT_DATA_LOADING = 'PAYMENT_DATA_LOADING';
export const PAYMENT_DATA_SUCCESS = 'PAYMENT_DATA_SUCCESS';
export const PAYMENT_DATA_FAILED = 'PAYMENT_DATA_FAILED';
